
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";

export const firebaseConfig = {
  apiKey: "AIzaSyB8cr8sm6s9ibZ3sVnKFrHfi1fstRfK6OU",
  authDomain: "cl-news-fc50b.firebaseapp.com",
  projectId: "cl-news-fc50b",
  storageBucket: "cl-news-fc50b.firebasestorage.app",
  messagingSenderId: "949100193410",
  appId: "1:949100193410:web:119b014c49f3b05e88b69b",
  databaseURL: "https://cl-news-fc50b-default-rtdb.firebaseio.com"
};

// Initialize Firebase (singleton pattern)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize and Export services as constants
export const auth = getAuth(app);
export const realtimeDb = getDatabase(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

console.log("Firebase services initialized correctly. Project ID:", firebaseConfig.projectId);

// Helper for dev testing
export const testFirestoreConnection = async () => {
  try {
    const snapshot = await getDocs(collection(db, 'news'));
    console.log(`Firestore connection OK: Found ${snapshot.size} docs.`);
    return true;
  } catch (e) {
    console.error("Firestore test failed:", e);
    return false;
  }
};

if (typeof window !== 'undefined') {
  window.testFirestoreConnection = testFirestoreConnection;
  window.firebaseApp = app;
}

export default app;
